import React, { useState } from "react";
import BotSvg from "../../assets/BotSvg";
import { botIconStyle } from "./style";
import ChatWindow from "./chatWindow";

const BotIcon: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button
    onClick={onClick}
    style={botIconStyle}
    aria-label="MLOps Agent"
  >
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <BotSvg width={22} height={22} />
      </span>
      <span style={{ marginRight: '10px' }}>TDSP Agent</span>
    </span>
  </button>
);

const MlopsAgent: React.FC = () => {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <>
      <BotIcon onClick={() => setChatOpen((prev) => !prev)} />
      {chatOpen && <ChatWindow onClose={() => setChatOpen(false)} />}
    </>
  );
};

export default MlopsAgent;
